import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class QuoteSyncService {
  getQuoteSyncs({ profileIds, quoteIds, cancelToken = null }) {
    return ApiService.post(
      `${Config.api.document.url}api/v1/quote-sync`,
      { profileIds, quoteIds },
      {
        cancelToken: cancelToken && cancelToken.token,
      },
    ).then((response) => response.data);
  }

  syncQuote({ opportunitySyncProfileId, quoteId, fieldValues = {} }) {
    return ApiService.post(`${Config.api.document.url}api/v1/quote-sync/synchronize`, {
      opportunitySyncProfileId,
      quoteId,
      fieldValues,
    }).then((response) => response.data);
  }
}

export const quoteSyncService = new QuoteSyncService();
